import { useState } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import HowItWorks from "@/components/HowItWorks";

import Features from "@/components/Features";
import TrustSection from "@/components/TrustSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import SEOHead from "@/components/SEOHead";
import UrgencyBanner from "@/components/UrgencyBanner";
import SegmentSelector, { getSavedSegment, type Segment } from "@/components/SegmentSelector";
import ProgressiveSignupForm from "@/components/ProgressiveSignupForm";

const Index = () => {
  // Skip modal if visitor already chose a segment in a previous session
  const [segment, setSegment] = useState<Segment | null>(getSavedSegment());
  const [showSelector, setShowSelector] = useState<boolean>(getSavedSegment() === null);
  const [showSignup, setShowSignup] = useState(false);

  const handleSegmentSelect = (s: Segment) => {
    setSegment(s);
    setShowSelector(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead />

      {/* Sticky urgency banner, sits above navbar */}
      <UrgencyBanner />

      <Navbar />

      {/* Segment selector modal, shown once per new visitor */}
      {showSelector && (
        <SegmentSelector
          onSelect={handleSegmentSelect}
          onDismiss={() => setShowSelector(false)}
        />
      )}

      {/* Progressive signup form, triggered by CTAs throughout the page */}
      {segment && (
        <ProgressiveSignupForm
          segment={segment}
          open={showSignup}
          onClose={() => setShowSignup(false)}
        />
      )}

      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <HowItWorks />
        
        <Features />
        <TrustSection />
        <CTASection />
      </main>

      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Index;
